import React from "react";
import { Input } from "@chakra-ui/react";
import TextField from "./TextField";

const ValueHelpField = (props) => {
  if (!props.field.dataSource || props.field.dataSource.type === "MANUAL") {
    return <TextField {...props} />;
  }

  return <Input value="Backend value-help endpoint pending" isReadOnly />;
};

export default ValueHelpField;
